import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { getAssignedUsersPageParamsSchema } from 'src/pages/shippers/organisations-and-users/schema';

export function useAssignedUsersPageParams() {
  return usePageParamsFromSchema(getAssignedUsersPageParamsSchema(), {
    filters: {
      shipperId: { label: 'Shipper' },
      organisationAssignmentStatus: { label: 'Shipper Assignment Status' },
      name: { label: 'User Name' },
      email: { label: 'User Email' },
      role: { label: 'User Role' },
      userAssignmentStatus: { label: 'User Assignment Status' },
      userStatus: { label: 'User Status' },
      tradingMarket: { label: 'Trading Market' },
    },
  });
}

export type AssignedUsersPageParams = ReturnType<
  typeof useAssignedUsersPageParams
>;
